import React from 'react';
import { createRoot } from 'react-dom/client';
// Side-effect import FIRST: applies the device-local global timezone override (luxon default zone)
// before any app module reads a date, so the very first paint is already in the chosen zone.
import './lib/timezone';
import App from './App';
import NotesApp from './components/notes/notes-app';
import 'sonner/dist/styles.css';
import './styles/app.css';

// The My Notes window loads the SAME bundle with ?window=notes (main.js appends it in dev
// and packaged loads alike) and mounts the small scratchpad root instead of the app shell.
const isNotesWindow = new URLSearchParams(window.location.search).get('window') === 'notes';

if (isNotesWindow) {
  // Pre-paint theme: the device copy in localStorage is shared across windows and kept
  // current by the main window on every theme change (App.jsx), so the first frame is
  // already in the right mode. Live changes arrive over IPC afterwards.
  try {
    document.documentElement.classList.toggle('dark', window.localStorage.getItem('healo-theme') === 'dark');
  } catch {
    /* storage unavailable — theme lands with the IPC boot state instead */
  }
}

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Unable to find root element for React mount.');
}

createRoot(rootElement).render(
  <React.StrictMode>{isNotesWindow ? <NotesApp /> : <App />}</React.StrictMode>,
);
